import React from 'react';
import {
  Button,
  Menu,
  Box,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useSaleCalendar } from './SaleCalendarContext';

export default function SaleCalendarFilters() {
  const { periods, filters, setFilters } = useSaleCalendar();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const allPeriodIds = React.useMemo(() => periods.map(p => p.id), [periods]);

  const handleFilters = React.useCallback(
    (name, value) => {
      setFilters(prev => ({
        ...prev,
        [name]: value
      }));
    },
    [setFilters]
  );

  const handleResetFilters = React.useCallback(() => {
    setFilters({});
  }, [setFilters]);

  const excludedPeriods = filters.excludedPeriods ?? [];

  const togglePeriod = id => {
    const newValue = excludedPeriods.includes(id)
      ? excludedPeriods.filter(pid => pid !== id) // usuń z wykluczonych
      : [...excludedPeriods, id]; // dodaj do wykluczonych
    handleFilters('excludedPeriods', newValue);
  };

  const toggleAllPeriods = () => {
    const isAllExcluded = excludedPeriods.length === allPeriodIds.length;
    handleFilters('excludedPeriods', isAllExcluded ? [] : allPeriodIds);
  };


  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FilterListIcon />}
        onClick={handleOpen}
      >
        Filtruj
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Box px={2} py={1} minWidth="280px">
          {/* Sekcja Terminy */}
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Terminy
          </Typography>

          <Box ml={2}>
            <FormGroup>
              {periods.map(period => (
                <FormControlLabel
                  key={period.id}
                  control={
                    <Checkbox
                      checked={!excludedPeriods.includes(period.id)}
                      onChange={() => togglePeriod(period.id)}
                    />
                  }
                  label={period.title}
                />
              ))}
            </FormGroup>

            <Box mt={1}>
              <Button onClick={toggleAllPeriods} size="small">
                {excludedPeriods.length === allPeriodIds.length
                  ? 'Zaznacz wszystkie'
                  : 'Odznacz wszystkie'}
              </Button>
            </Box>
          </Box>

          {/* Globalny reset filtrów */}
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button onClick={handleResetFilters} size="small">
              Resetuj
            </Button>
          </Box>
        </Box>
      </Menu>
    </>
  );
}
